import React from 'react';
import ReactDom from "react-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';

function ExperienceCards(props) {
  AOS.init();

  return (
    <div>

      <table className="experience-table">
          <tr className="experience-tr">
            <td className="experience-td-picture">
                <img className="experience-pictures" src={`${process.env.PUBLIC_URL}${props.image}`} alt={props.title} />
            </td>
            <td className="experience-td-info">
              <div  className="experience-card-info">
                <h2 className="title-heading2"> {props.title} </h2>
                <p className="experience-meta"> <em> {props.date} </em>  <br /> <em> {props.location} </em> <br /> <em> {props.position} </em> </p>
                {props.description ? (
                  <p className="experience-description"> {props.description}</p>
                ) : null}
              </div>
            </td>
          </tr>
      </table>

    </div>
);

}

export default ExperienceCards;
